export const manualLabelInstructionsDefault = [
  "The product your returning requires a manual label to be generated, our team has been notified.",
  "Please look out for an email from us with instructions.",
];
